import { createSlice } from '@reduxjs/toolkit';

import {
  fetchInterviewDetails,
  fetchEventId,
  fetchInterviewsEvent,
  fetchInterviewersList,
  fetchSuggestedInterviewerId,
  fetchCreatedInterview,
  fetchScheduledInterview,
} from './actions';

const initialState = {
  isLoading: false,
  interviewDetails: {},
  createdInterviewDetails: {},
  eventFetchId: '',
  interviewersEvents: {},
  interviewersList: {},
  weekRange: {},
  duration: '',
  events: [],
  suggestedInterviewId: '',
  timezone: '',
};

export const { reducer, actions } = createSlice({
  name: 'scheduling',
  initialState,
  reducers: {
    updateWeekRange: (state, action) => {
      state.weekRange = action.payload;
    },
    updateDuration: (state, action) => {
      state.duration = action.payload;
    },
    updateEvents: (state, action) => {
      state.events = action.payload;
    },
    updateTimezone: (state, action) => {
      state.timezone = action.payload;
    },
    resetInterview: (state) => {
      state.interviewDetails = {};
      state.createdInterviewDetails = {};
    },
    resetInterviewerId: (state) => {
      state.suggestedInterviewId = '';
      state.eventFetchId = '';
    },
  },
  extraReducers: {
    [fetchInterviewDetails.pending]: (state) => {
      state.isLoading = true;
    },
    [fetchInterviewDetails.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.interviewDetails = payload?.data?.interview || {};
    },
    [fetchInterviewDetails.rejected]: (state) => {
      state.isLoading = true;
    },

    [fetchEventId.pending]: (state) => {
      state.isLoading = true;
    },
    [fetchEventId.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.eventFetchId = payload.data;
    },
    [fetchEventId.rejected]: (state) => {
      state.isLoading = true;
    },

    [fetchInterviewsEvent.pending]: (state) => {
      state.isLoading = true;
    },
    [fetchInterviewsEvent.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.interviewersEvents = payload.data;
    },
    [fetchInterviewsEvent.rejected]: (state) => {
      state.isLoading = true;
    },
    [fetchInterviewersList.pending]: (state) => {
      state.isLoading = true;
    },
    [fetchInterviewersList.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.interviewersList = payload.data;
    },
    [fetchInterviewersList.rejected]: (state) => {
      state.isLoading = true;
    },

    [fetchSuggestedInterviewerId.pending]: (state) => {
      state.isLoading = true;
    },
    [fetchSuggestedInterviewerId.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.suggestedInterviewId = payload.data;
    },
    [fetchSuggestedInterviewerId.rejected]: (state) => {
      state.isLoading = true;
    },

    [fetchCreatedInterview.pending]: (state) => {
      state.isLoading = true;
    },
    [fetchCreatedInterview.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.createdInterviewDetails = payload.data;
    },
    [fetchCreatedInterview.rejected]: (state) => {
      state.isLoading = true;
    },

    [fetchScheduledInterview.pending]: (state) => {
      state.isLoading = true;
    },
    [fetchScheduledInterview.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.createdInterviewDetails = {
        ...payload.data,
        kind: payload?.data?.interview_kind,
      };
      state.duration = payload?.data?.duration;
    },
    [fetchScheduledInterview.rejected]: (state) => {
      state.isLoading = true;
    },
  },
});

export const {
  updateWeekRange,
  updateDuration,
  updateEvents,
  updateTimezone,
  resetInterview,
  resetInterviewerId,
} = actions;
export default reducer;
